import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const TestimonialViewModal = ({ isOpen, onClose, testimonial, loading }) => {
  if (!isOpen) return null;

  const API_BASE = "https://algoritm-api-edu.uz";

  return (
    <AnimatePresence>
      <motion.div
        className="modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="modal-content"
          initial={{ scale: 0.85, y: 60 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.85, y: 60 }}
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "780px",
            borderRadius: "16px",
            padding: "32px",
            maxHeight: "90vh",
            overflowY: "auto",
            background: "#fff",
          }}
        >
          <h3
            style={{
              margin: "0 0 28px",
              fontSize: "24px",
              fontWeight: 700,
              color: "#1f2937",
            }}
          >
            Fikr-mulohaza ma'lumotlari
          </h3>

          {loading ? (
            <div style={{ textAlign: "center", padding: "120px 0" }}>
              Yuklanmoqda...
            </div>
          ) : testimonial ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "28px" }}
            >
              {testimonial.photoUrl && (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={
                      testimonial.photoUrl.startsWith("http")
                        ? testimonial.photoUrl
                        : `${API_BASE}/${testimonial.photoUrl}`
                    }
                    alt={testimonial.studentName}
                    style={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "4px solid #e0e7ff",
                      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    }}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/180/6366f1/ffffff?text=" +
                        (testimonial.studentName?.[0] || "?");
                    }}
                  />
                </div>
              )}

              <div style={{ display: "grid", gap: "20px", fontSize: "15px" }}>
                <div>
                  <strong style={{ color: "#374151" }}>Ism:</strong>{" "}
                  <span style={{ fontWeight: 600 }}>
                    {testimonial.studentName || "—"}
                  </span>
                </div>

                <div>
                  <strong style={{ color: "#374151" }}>Fikr:</strong>
                  <p
                    style={{
                      marginTop: "10px",
                      whiteSpace: "pre-wrap",
                      lineHeight: "1.7",
                      color: "#4b5563",
                      background: "#f9fafb",
                      padding: "16px",
                      borderRadius: "10px",
                      borderLeft: "4px solid #6366f1",
                    }}
                  >
                    {testimonial.message || "Ma'lumot kiritilmagan"}
                  </p>
                </div>

                {testimonial.videoUrl && (
                  <div>
                    <strong style={{ color: "#374151" }}>Video:</strong>
                    <div
                      style={{
                        marginTop: "12px",
                        borderRadius: "12px",
                        overflow: "hidden",
                        boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                      }}
                    >
                      <video
                        controls
                        style={{ width: "100%", maxHeight: "400px" }}
                      >
                        <source
                          src={
                            testimonial.videoUrl.startsWith("http")
                              ? testimonial.videoUrl
                              : `${API_BASE}/${testimonial.videoUrl}`
                          }
                          type="video/mp4"
                        />
                        Brauzeringiz video elementini qo‘llab-quvvatlamaydi.
                      </video>
                    </div>
                  </div>
                )}

                <div>
                  <strong style={{ color: "#374151" }}>Status:</strong>{" "}
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      background: "#ecfdf5",
                      color: "#10b981",
                      fontWeight: "600",
                    }}
                  >
                    Faol / Tasdiqlangan
                  </span>
                </div>

                <div>
                  <strong style={{ color: "#374151" }}>ID:</strong>{" "}
                  <span style={{ fontFamily: "monospace", color: "#6b7280" }}>
                    {testimonial.id}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "100px 0",
                color: "#e74c3c",
              }}
            >
              Ma'lumot topilmadi
            </div>
          )}

          <div style={{ marginTop: "36px", textAlign: "right" }}>
            <button
              onClick={onClose}
              style={{
                padding: "12px 32px",
                background: "#f1f5f9",
                border: "none",
                borderRadius: "10px",
                fontWeight: 600,
                cursor: "pointer",
                fontSize: "15px",
              }}
            >
              Yopish
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TestimonialViewModal;
